import {css, StyleSheet} from 'aphrodite';
import React from 'react';

import {GRAY_DARK} from 'ui-library/Colors';
import {Optional} from 'util/Types';

const DEFAULT_PLACEHOLDER_VALUE = 'No value';

export interface PlaceholderTextProps {
  /**
   * value is the text used for the placeholder. If not provided, the fallback is 'No value'.
   */
  value: Optional<string>;
}

/**
 * Renders a placeholder text value or 'No value' if none provided.
 */
export default function PlaceholderText({value}: PlaceholderTextProps): JSX.Element {
  const text = value === undefined ? DEFAULT_PLACEHOLDER_VALUE : value;
  return <span className={css(styles.placeholderText)}>{text}</span>;
}

export const styles = StyleSheet.create({
  placeholderText: {
    color: GRAY_DARK,
  },
});
